<template>
  <div>
    <gs-modal
      v-model="visible"
      :before-close="beforeClose"
      :title="'所有事件'"
      class="my-test-class"
      @close="close"
      @confirm="handleConfirm"
    >
      <fieldset>
        <legend>所有事件</legend>
          <gs-table
            ref = 'selectionTable'
            :data="tableList"
            @selection-change="getSelections"
            @row-click="handleRowClick"
          >
            <gs-table-column
              type="selection"
            />
            <gs-table-column
              prop="formDate"
              label="开始日期"
            />
            <gs-table-column
              prop="toDate"
              label="结束日期"
            />
            <gs-table-column
              prop="startTime"
              label="开始时间"
            />
            <gs-table-column
              prop="stopTime"
              label="结束时间"
            />
            <gs-table-column
              prop="weekDays"
              label="星期"
            />
          </gs-table>
        <!-- <gs-pagination
          ref="pagination"
          :current="currentPage"
          :total="parseInt(tableList.length/5)+1"
          :before-jump="page => beforeJump(page, 'pagination')"
          style="margin-top:20px;"
          layout="simplepager,jumper,jumpbtn"
        /> -->
        <div>
          <gs-button @click="openNewAdd">新建</gs-button>
          <gs-button @click="edit">编辑</gs-button>
          <gs-button @click="del">删除</gs-button>
        </div>
      </fieldset>
    </gs-modal>
  </div>
</template>

<script type="text/ecmascript-6">
import eventBus from './vue.js'
import moment from 'moment'
import checkRepeat from '../../utils/checkRepeat.js'
export default {
  components: {

  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    eventsList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      tableList: [],
      radio: {},
      editData: {},
      currentPage: 1,
      multipleSelection:[],
      selection: []
    }
  },
  computed: {
    showList () {
      return this.tableList.slice((this.currentPage - 1) * 5, this.currentPage - 1 === 0 ? 4 : this.currentPage * 5 - 1)
    }
  },
  watch: {
    visible () {
      if (this.visible) {
        this.tableList = this.eventsList
      } else {
        this.tableList = []
      }
    }
  },
  created () {

  },
  mounted () {
    let _this = this
    eventBus.$on('timeChartList', (list) => {
      _this.tableList = list
      _this.tableList = checkRepeat(_this.tableList, 'id')
    })
  },
  methods: {
    getSelections (selection) {
      if(selection.length>1){
        this.$refs.selectionTable.clearSelection()
        this.$refs.selectionTable.toggleRowSelection(selection.pop())
      }else{
        this.selection=selection
      }
    },
    handleRowClick(row,column,event){
      this.$refs.selectionTable.toggleRowSelection(row)
    },
    beforeClose () {
      this.$emit('closeAllEvent', true)
    },
    close () {
      this.$emit('closeAllEvent', true)
    },
    handleConfirm (val) {
      this.eventsList = this.selection
      this.$emit('closeAllEvent', true)
    },
    openNewAdd () {
      eventBus.$emit('openNewAdd', true)
    },
   /* beforeJump (page, pagination = 'pagination') {
      if (isNaN(page) || page < 1 || page > this.$refs[pagination].totalPage) {
        this.$Message.error('请输入正确页数')
        return false
      }
    },*/
    checkChange () {

    },
    del () {
      let arr = this.tableList
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id === this.radio.id) {
          arr.splice(i, 1)
        }
      }
    },
    edit () {
      if (!this.radio) {

      } else {

      }
      this.editData = this.radio
      eventBus.$emit('openNewAdd', true)
      if (this.editData.formDate.indexOf('*') === 0) {
        this.editData.formDate = new Date().getFullYear() + this.editData.formDate.substr(4, 6)
      }
      if (this.editData.toDate.indexOf('*') === 0) {
        this.editData.toDate = new Date().getFullYear() + this.editData.toDate.substr(4, 6)
      }
      if (this.editData.formDate === '-') {
        this.editData.formDate = moment(new Date()).format('YYYY-MM-DD')
      }
      if (this.editData.toDate === '-') {
        this.editData.toDate = moment(new Date()).format('YYYY-MM-DD')
      }
      eventBus.$emit('editTimeChart', this.editData)
    }
  }
}
</script>
<style>
  fieldset {
        padding: 12px;
        border-radius: 5px;
        border: solid 2px #d9d9d9
        }
</style>




// WEBPACK FOOTER //
// src/components/timeChart/allEvent.vue